import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { CandidateActions } from '@pflegia/types/common/enums/post-back/candidate-actions.enum';

import { UTM_TRACKING_STORE_NAME } from './constants';

type UtmPayload = Record<string, unknown>;
type StoreState = {
  trackedActions: Partial<Record<CandidateActions, UtmPayload | null>>;
};

type StoreCallbacks = {
  set: (action: CandidateActions, updates: UtmPayload) => void;
};

const DEFAULT_STATE: StoreState = {
  trackedActions: {},
};

export const useUtmTrackingStore = create<StoreState & StoreCallbacks>()(
  persist(
    set => ({
      ...DEFAULT_STATE,
      set: (action, updates) =>
        set(state => ({
          ...state,
          trackedActions: {
            ...state.trackedActions,
            [action]: updates,
          },
        })),
    }),
    {
      name: UTM_TRACKING_STORE_NAME,
      storage: createJSONStorage(() => window.localStorage),
    },
  ),
);
